import { CommonState } from '~/store/commonStore'

export const getHistory = (state: CommonState) => state.pages.historyPage
